import { useState } from 'react';
import Controls from './components/Controls';
import { UseContextProvider } from './contexts/StepperContext';
import UserInfo from './components/steps/UserInfo';
import Card from 'components/card';

const NewUser = () => {
  const [currentStep, setCurrentStep] = useState(1);

  const steps = [
    { stepNo: 1, name: 'User Info' },
  ];
  const displayStep = () => <UserInfo />;

  const handleClick = (direction: string) => {
    let newStep = currentStep;

    direction === 'next' ? newStep++ : newStep--;
    // check if steps are within bounds
    newStep > 0 && newStep <= steps.length && setCurrentStep(newStep);
  };
  return (
    <div className="mt-3 h-full w-full">
      {/* Coming Soon Banner */}
      <div className="mb-4 px-4 py-3 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-xl">
        <div className="flex items-center gap-2">
          <span className="text-[10px] px-1.5 py-0.5 rounded bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400 font-medium">
            Coming Soon
          </span>
          <p className="text-sm text-yellow-700 dark:text-yellow-400">
            This feature is currently under development and will be available soon.
          </p>
        </div>
      </div>
      <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600 md:h-[390px]" />
      <div className="w-md:2/3 mx-auto h-full w-5/6 md:px-3 3xl:w-7/12">
        <div className="-mt-[280px] w-full pb-10 md:-mt-[240px]">
          <Card extra={'h-full mx-auto pb-3 shadow-lg'}>
            <div className="rounded-[20px]">
              <UseContextProvider>
                {displayStep()}
              </UseContextProvider>
            </div>

            <Controls
              handleClick={handleClick}
              currentStep={currentStep}
              steps={steps}
            />
          </Card>
        </div>
      </div>
    </div>
  );
};

export default NewUser;
